// extracted by mini-css-extract-plugin
export default {"form_label":"render-label_form_label__vHiGA","form_required":"render-label_form_required__hb4BZ"};